<template>
  <!-- Page Content -->
  <div id='page-wrapper'>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
    <div class='container-fluid'>
      <div class='row'>
        <div class='col-lg-12'>
          <h1 class='page-header'>اليومية</h1>
        </div>
        <!-- /.col-lg-12 -->
      </div>
      <!-- /.row -->
      <div class='row'>
        <div class='col-lg-12'>
          <div class='panel panel-default'>
            <div class='panel-heading'>
              هنا يتم ادخال وعرض يومية الحسابات
              <div class='pull-left' style='padding=0px'>
                <button @click="newEntry()" type='button' class='btn btn-outline btn-primary btn-sm ' style='padding:3px;width: 80px' data-toggle='modal' data-target='#myModal'>
                  <b>  إضافة جديد </b>
                </button>
              </div>
            </div>
            <!-- /.panel-heading -->
            <div class='panel-body'>
              <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='validationErrors'>
                <ul v-if='validationErrors'>
                  <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                </ul>
              </div>
              <div class='col-lg-4 col-md-4 col-sm-6' style="padding: 5px">
                <label>الفرع</label>
                <select  @change='UpdateData($event.target.value)' class="form-control" style="padding: 0px" v-model="branche_id">
                  <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                    {{ item.name }}
                  </option>
                </select>
              </div>
              <div class='col-lg-4 col-md-4 col-sm-6' style="padding: 5px">
                <label>الخزنة:</label>
                <select class="form-control" style="padding: 0px" v-model="treasury_id">
                  <option v-for="treasury in treasuries" v-bind:key="treasury.id" v-bind:value="treasury.id">
                    {{ treasury.name }}
                  </option>
                </select>
              </div>
              <div class='col-lg-4 col-md-4 col-sm-6' style="padding: 5px">
                <label>المحصل:</label>
                <select class="form-control" style="padding: 0px" v-model="collector_id">
                  <option v-for="collector in collectors" v-bind:key="collector.id" v-bind:value="collector.id">
                    {{ collector.name }}
                  </option>
                </select>
              </div>
              <div class='col-lg-4 col-md-4 col-sm-6' style="padding: 5px">
                <tbDate  :mytitle='dateTitle' v-model= 'dayDate' ></tbDate>
              </div>
              <div style="padding-top:30px" class='col-lg-4 col-md-4 col-sm-6'>
                <button type='button'  @click='FillGrid()' class='btn btn-outline btn-primary btn-md btn-block ' style='padding:3px;width: 60px'>
                  <b> عرض </b>
                </button>
              </div>
              <div style="padding-top:30px" class='col-lg-4 col-md-4 col-sm-6'>
                <button v-simple-print="'contentToPrint'" type='button' class='btn btn-outline btn-primary btn-md btn-block ' style='padding:3px;width: 60px'>
                  <b> طباعة </b>
                </button>
              </div>
              <br>
              <br>
              <br>
              <br>
              <div id="contentToPrint"  style="padding-top: 5px">
                <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                  <thead>
                    <tr>
                      <th style='padding:2px;text-align: center'>م</th>
                      <th style='padding:2px;text-align: center'>السجل</th>
                      <th style='padding:2px;text-align: center'>الاسم</th>
                      <th style='padding:2px;text-align: center'>صيانة</th>
                      <th style='padding:2px;text-align: center'>عروض</th>
                      <th style='padding:2px;text-align: center'>تحصيل قسط</th>
                      <th style='padding:2px;text-align: center'>تحصيل صيانة</th>
                      <th style='padding:2px;text-align: center'>باقى الصيانة</th>
                      <th style='padding:2px;text-align: center'>الأقساط</th>
                      <th style='padding:2px;text-align: center'>بداية القسط</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class='odd gradeX' v-for='(record,index) in records' :key='record.id'>

                      <td align='center'>{{index +1 }}</td>
                      <td align='center'>{{record.rec_id}}{{record.rec_id_letter}}</td>
                      <td align='center'>{{record.name}}</td>
                      <td align='center'>{{record.items_ids}}</td>
                      <td align='center'>{{record.offer_id}}</td>
                      <td align='center'>{{record.premium_collection}}</td>
                      <td align='center'>{{record.maintenance_collection}}</td>
                      <td align='center'>{{record.maintenance_debt}}</td>
                      <td align='center'>{{record.maintenance_count}}</td>
                      <td align='center'>{{record.maintenance_start}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.table-responsive -->
            </div>
            <!-- /.panel-body -->
          </div>
          <!-- /.panel -->
        </div>
        <!-- /.col-lg-12 -->
      </div>
    </div>
    <!-- Modal -->
    <div class='modal fade' id='myModal' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
      <div class='modal-dialog  modal-lg'>
        <div class='modal-content'>
          <div class='modal-header'>
            <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
            <h4 class='modal-title' id='myModalLabel'>إضافة عملية جديدة</h4>
          </div>
          <form role='form'>
            <div class='modal-body'>
              <div class='alert alert-danger alert-dismissable' v-if='validationModelErrors'>
                <ul v-if='validationModelErrors'>
                  <li v-for='err in validationModelErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                </ul>
              </div>
              <div class='alert alert-success alert-dismissable' v-if='successShow'>
                {{success}}
              </div>
              <fieldset>
                <div class="row" style="padding: 5px;">
                <div class='col-lg-4 col-md-4 col-sm-6'>
                  <label>الفرع</label>
                  <select  @change='UpdateData($event.target.value)' class="form-control"  v-model="branche_id">
                    <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                <div class='col-lg-4 col-md-4 col-sm-6'>
                  <label>الخزنة:</label>
                  <select class="form-control" style="padding: 0px" v-model="treasury_id">
                    <option v-for="treasury in treasuries" v-bind:key="treasury.id" v-bind:value="treasury.id">
                      {{ treasury.name }}
                    </option>
                  </select>
                </div>
                <div class='col-lg-4 col-md-4 col-sm-6'>
                    <label>المخزن:</label>
                    <select class="form-control" style="padding: 0px" v-model="store_id">
                      <option v-for="store in stores" v-bind:key="store.id" v-bind:value="store.id">
                        {{ store.name }}
                      </option>
                    </select>
                </div>
                <div class='col-lg-4 col-md-4 col-sm-6'>
                  <tbDate  :mytitle='dateTitle' v-model= 'dayDate' ></tbDate>
                </div>
                <div class='col-lg-4 col-md-4 col-sm-6'>
                  <label>المحصل:</label>
                  <select class="form-control" style="padding: 0px" v-model="collector_id">
                    <option v-for="collector in collectors" v-bind:key="collector.id" v-bind:value="collector.id">
                      {{ collector.name }}
                    </option>
                  </select>
                </div>
                <div class='col-lg-4 col-md-4 col-sm-6'>
                  <label>الكود:</label>
                  <input @keypress="isNumber($event)" ref="code" v-on:keypress="GetData($event)" v-model='recID' class='form-control' type='text'>
                </div>
              </div>
                <div v-if='alert_class || isLoadingRecData' style="padding: 5px;">
                  <div  :class="alert_class" style="padding-top: 10px;height: 40px;margin:0px ">
                    <vue-element-loading size='32' :active='isLoadingRecData' spinner='bar-fade-scale' color='#A4A4A4'/>
                    <div v-if="!CustomerDataErr">
                      <div v-if="!isLoadingRecData" class="col-lg-6 col-md-6 col-sm-6">
                        <b>  الاسم: </b>  {{record.name}}
                      </div>
                      <div v-if="!isLoadingRecData" class="col-lg-6 col-md-6 col-sm-6">
                        <b>المحمول: </b>  {{record.mobile}}
                      </div>
                    </div>
                    <div v-if="CustomerDataErr">
                      عفوا العميل غير موجود
                    </div>
                  </div>
                </div>
                <div class="row" style="padding: 5px;">
                  <div class='col-lg-6 col-md-6 col-sm-6'>
                    <label >أصناف الصيانة:</label>
                    <input ref="items" v-on:keypress="code_change($event)" v-model='code' class='form-control' type='text'>
                  </div>
                  <div class='col-lg-6 col-md-6 col-sm-6'>
                    <label >كود العرض: <code v-if="Offer_name">{{Offer_name}}</code></label>
                    <input ref="offer" v-on:keypress="offer_foucs($event)" v-model='offer' class='form-control' type='text'>
                  </div>
                  </div>
                  <div class="row" style="padding: 5px;">
                    <div class='col-lg-4 col-md-4 col-sm-4'>
                      <label>صيانة سابقة</label>
                      <input :value='oldMain' readonly class='form-control' type='text'>
                    </div>
                    <div class='col-lg-4 col-md-4 col-sm-4'>
                      <label>صيانة حالية</label>
                      <input :value='totalMain' readonly class='form-control' type='text'>
                    </div>
                    <div class='col-lg-4 col-md-4 col-sm-4'>
                      <label>إجمالى الصيانة</label>
                      <input :value='allMain' readonly class='form-control' type='text'>
                    </div>
                  </div>
                  <div class="row" style="padding: 10px 0px 10px 0px;">
                <div class='col-lg-2 col-md-2 col-sm-2'>
                  <label>تحصيل قسط:</label>
                  <input @keypress="isNumber($event)" ref="pay_Installment" v-on:keypress="payInstallment_foucs($event)" v-model='payInstallment' class='form-control' type='text'>
                </div>
                <div class='col-lg-2 col-md-2 col-sm-2'>
                  <label>تحصيل صيانة:</label>
                  <input @keypress="isNumber($event)" ref="payMaintenance" v-on:keypress="payMaintenance_foucs($event)" v-model='payMaintenance' class='form-control' type='text'>
                </div>
                <div class='col-lg-2 col-md-2 col-sm-2'>
                  <label>باقى صيانة:</label>
                  <input @keypress="isLocked($event)" v-on:keypress="payMaintenance_foucs($event)" v-model='maintenance_debt' class='form-control' type='text'>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-3'>
                  <label>عدد اقساط الصيانة:</label>
                  <input ref="MaintenanceCount" v-on:keypress="MaintenanceCount_foucs($event)" v-model='MaintenanceCount' class='form-control' type='text'>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-3'>
                  <tbDate  :mytitle='dateTitleMainta' v-model= 'firstInstallment' ></tbDate>
                </div>
              </div>
                <table v-if="listItems" width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                  <thead>
                    <tr>
                      <th style='padding:2px;text-align: center'>م</th>
                      <th style='padding:2px;text-align: center'>الصنف</th>
                      <th style='padding:2px;text-align: center'>تم تغيير</th>
                      <th style='padding:2px;text-align: center'>العدد المجانى</th>
                      <th style='padding:2px;text-align: center'>السعر</th>
                      <th style='padding:2px;text-align: center'>المطلوب</th>
                      <th style='padding:2px;text-align: center'>العرض</th>
                      <th style='padding:2px;text-align: center'>العدد</th>
                      <th style='padding:2px;text-align: center'>تم التركيب</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class='odd gradeX' v-for='(record,index) in listItems' :key='index'>

                      <td align='center'>{{index +1 }}</td>
                      <td align='center'>{{record.item}}</td>
                      <td align='center'>{{record.sort}}</td>
                      <td align='center'>{{record.free_pics}}</td>
                      <td align='center'>{{record.price}}</td>
                      <td align='center'>{{record.fee}}</td>
                      <td align='center'>{{record.offer_id}}</td>
                      <td align='center'>{{record.item_pieces}}</td>
                      <td align='center'><input type="checkbox" v-model="record.ischanged "></td>
                    </tr>
                  </tbody>
                </table>
              </fieldset>
            </div>
            <div class='modal-footer'>
              <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
              <button @click='savePaymments()' type='button' class='btn btn-primary'>حفظ</button>
              <button @click='newEntry()' type='button' class='btn btn-primary'>جديد</button>
              <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
            </div>
          </form>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
    <!-- /.container-fluid -->
  </div>
</template>
<script>
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
export default {
  components: {
    tbDate
  },
  name: 'dailyaccounts',
  data () {
    return {
      dateTitle: 'التاريخ',
      dateTitleMainta: 'بداية اول قسط صيانة:',
      dayDate: '',
      showCustomerData: false,
      CustomerDataErr: '',
      validationErrors: '',
      validationModelErrors: '',
      maintenance_debt: '',
      Offer_name: '',
      records: {},
      listItems: [],
      record: {},
      recID: null,
      code: null,
      recIDError: null,
      dues_payment: null,
      branches: {},
      branche_id: '',
      collectors: {},
      stores: {},
      collector_id: '',
      items: {},
      offers: {},
      action: null,
      alert_class: null,
      isLoadingRecData: false,
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      isLoadingDelete: false,
      title: '',
      totalMain: 0,
      treasuries: {},
      emp: '',
      treasury_id: '',
      date_even: '',
      date_to: '',
      title_name: '',
      title_from: '',
      title_to: '',
      store_id: '',
      // ----------------------
      offer: '',
      MaintenanceCount: '',
      payMaintenance: '',
      payInstallment: '',
      firstInstallment: '',
      oldMain: 0,
      allMain: 0
    }
  },
  watch: {
    payMaintenance (val) {
      this.maintenance_debt = this.allMain - val
    }
  },
  created () {
    this.record = ''
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.branche_id = this.branches[0].id
    this.UpdateData(this.branche_id)
  },
  methods: {
    newEntry () {
      this.record = ''
      this.recID = ''
      this.listItems = []
      this.totalMain = 0
      this.code = ''
      this.offer = ''
      this.maintenance_debt = ''
      this.MaintenanceCount = ''
      this.payMaintenance = ''
      this.payInstallment = ''
      this.firstInstallment = ''
      this.Offer_name = ''
      this.alert_class = null
      this.oldMain = 0
      this.allMain = 0
      this.validationModelErrors = ''
      this.successShow = false
      this.errorShow = false
      this.$refs.code.focus()
    },
    UpdateData (id) {
      this.branches = JSON.parse(localStorage.getItem('Branches'))
      let i = this.branches.findIndex(x => x.id === parseInt(id))
      if (i > -1) {
        this.treasuries = this.branches[i].treasuries
        this.collectors = this.branches[i].collectors
        this.stores = this.branches[i].stores
      }
    },
    GetData (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if (charCode === 43) {
        evt.preventDefault()
        this.record = []
        this.isLoadingRecData = true
        this.showCustomerData = true
        this.CustomerDataErr = null
        axios.post(this.$apiURL + 'getDailyAccounts', {
          token: localStorage.getItem('token'),
          id: this.recID,
          branche_id: this.branche_id
        })
          .then(({ data }) => {
            this.record = data.data
            this.items = data.items
            this.offers = data.Offers
            this.oldMain = data.maintenance_ind
            this.$refs.items.focus()
            this.isLoadingRecData = false
            this.alert_class = 'alert alert-success'
          })
          .catch(err => {
            if (err.response.data.errors === 'Forbidden') {
              this.$router.push('accessdeny')
            }
            if (err.response.status === 401) {
              this.$router.push('login')
            }
            this.CustomerDataErr = err.response.data.errors
            this.showCustomerData = false
            this.isLoadingRecData = false
            this.alert_class = 'alert alert-danger alert-dismissable'
          })
      }
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    // --------------------------------------------------
    FillGrid () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'get-daily', {
        treasury_id: this.treasury_id,
        dayDate: this.dayDate,
        collector_id: this.collector_id,
        token: localStorage.getItem('token')
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
          this.validationErrors = err.response.data.errors
        })
    },
    // --------------------------------------------------
    code_change (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if (charCode === 43) {
        evt.preventDefault()
        var arr = this.code.split('-')
        if (Array.isArray(arr) && arr[0].length) {
          var i
          for (i = 0; i < arr.length; i++) {
            let r = this.items.findIndex(x => x.item_id === parseInt(arr[i]))
            if (r > -1) {
              this.listItems.push(this.items[r])
              this.totalMain = this.totalMain + this.items[r].fee
              this.allMain = this.totalMain + this.oldMain
            }
          }
        }
        this.$refs.offer.focus()
      }
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 && charCode !== 45) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    // --------------------------------------------------
    offer_foucs (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if (charCode === 43) {
        evt.preventDefault()
        var arr = this.offer.split('-')
        if (Array.isArray(arr) && arr[0].length) {
          var i
          for (i = 0; i < arr.length; i++) {
            let r = this.offers.findIndex(x => x.id === parseInt(arr[i]))
            if (r > -1) {
              var c
              this.Offer_name = this.offers[r].offer_name
              for (c = 0; c < this.offers[r].offer_items.length; c++) {
                this.listItems.push(this.offers[r].offer_items[c])
                this.totalMain = this.totalMain + this.offers[r].offer_items[c].fee
                this.allMain = this.totalMain + this.oldMain
              }
            }
          }
        }
        this.$refs.pay_Installment.focus()
      }
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    // --------------------------------------------------
    payInstallment_foucs (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if (charCode === 43) {
        this.$refs.payMaintenance.focus()
      }
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    // --------------------------------------------------
    payMaintenance_foucs (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if (charCode === 43) {
        this.$refs.MaintenanceCount.focus()
      }
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    // --------------------------------------------------
    MaintenanceCount_foucs (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if (charCode === 43) {
        this.$refs.firstInstallment.focus()
      }
    },
    // --------------------------------------------------
    savePaymments () {
      this.record = []
      this.validationModelErrors = ''
      this.successShow = false
      this.errorShow = false

      this.isLoadingSave = true
      this.showCustomerData = true
      this.CustomerDataErr = null
      axios.post(this.$apiURL + 'savePaymentsDaily', {
        token: localStorage.getItem('token'),
        id: this.recID,
        treasury_id: this.treasury_id,
        dayDate: this.dayDate,
        collector_id: this.collector_id,
        payInstallment: this.payInstallment,
        payMaintenance: this.payMaintenance,
        MaintenanceCount: this.MaintenanceCount,
        store_id: this.store_id,
        firstInstallment: this.firstInstallment,
        listItems: this.listItems,
        offer_id: this.offer,
        items_ids: this.code,
        maintenance_debt: this.maintenance_debt,
        branch_id: this.branche_id
      })
        .then(({ data }) => {
          this.records = data
          this.successShow = true
          this.errorShow = false

          this.isLoadingSave = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.validationModelErrors = err.response.data.errors
          this.successShow = false
          this.errorShow = true
          this.isLoadingSave = false
        })
    },
    // --------------------------------------------------
    isLocked: function (evt) {
      evt.preventDefault()
    },
    isNumber: function (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Accounts/DailyAccounts.vue